import React from 'react';
import classNames from 'classnames'

import { timeframeToLocalizedString, kindToLocalizedString } from "../../helpers";

import styles from './index.sass'

export default ({event, className, ...props}) =>
    <span className={classNames([styles.root, className])}>

        <span className="kind label">
            <span><b>{event.venue !== undefined && event.venue.location.city.name}</b>{kindToLocalizedString(event.kind)}</span>
        </span>

        <span className="timeframe label">
            <span dangerouslySetInnerHTML={{ __html: timeframeToLocalizedString(event.timeframe) }} />
        </span>

        {event.timeframe && new Date() < new Date(event.timeframe.start)
            ? <span className="upcoming label"><span>Wkrótce</span></span>
            : null // <span className="past label"><span>Done</span></span>
        }
    </span>



// WEBPACK FOOTER //
// ./src/modules/Events/elements/EventMetadata/index.js